import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { SbApiService } from '../services/sb-api.service';
import { SiteModel, WorkflowModel } from '../models/site.model';
import { SblibService } from '../sb-manager/sb-editor/services/sblib.service';
import { MinisiteConfiguration } from '@3ddv/ngx-sites-builder-lib';
import { ClientService } from 'src/app/auth/private/components/client/services/client.service';
import { ClientListFromKeys } from 'src/app/auth/private/components/client/models/client.model';
import { VenuesService } from 'src/app/venues/private/services/venues.service';
import { CdVenueModel } from 'src/app/content-distribution/private/entities/venues/models/venue.model';
import { ContentDistributionApiService } from 'src/app/content-distribution/private/services/content-distribution-api.service';

@Injectable({
  providedIn: 'root',
})
export class FlowListResolver {
  constructor(
    private sbApiService: SbApiService,
    private toastr: ToastrService,
    private router: Router
  ) { }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.sbApiService.getFlowsList().pipe(
      map(list => list),
      catchError(error => {
        this.toastr.error('', 'Se ha producido un error');
        this.router.navigate(['/dashboard']);
        return of({ list: null, error: error });
      })
    );
  }
}

@Injectable({
  providedIn: 'root',
})
export class FlowInfoResolver {
  constructor(
    private sbApiService: SbApiService,
    private toastr: ToastrService,
    private router: Router,
    private cdistApiService: ContentDistributionApiService,
    private clientAuthAPIService: ClientService,
    private venuesService: VenuesService
  ) { }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const workflowId = route.params['workflowId'];
    return this.sbApiService.getFlow(workflowId).pipe(
      mergeMap(response => {
        return new Observable<{
          workflow: WorkflowModel;
          venue: CdVenueModel;
          clients: ClientListFromKeys[];
        }>(subscriber => {
          let p = route.queryParams;
          if (p['venue_id'] && p['map_id']) {
            response.workflow.map_id = p['map_id'];
            response.workflow.venue_id = p['venue_id'];
            /*             response.workflow.tools.map(t => {
              if (t.name === 'Minimap') {
                t.values.map_id = response.workflow.map_id;
              }
            }); */
          }
          // console.log(response);
          return this.cdistApiService.getClientsByCode(response.workflow.venue_id).subscribe(cdistReponse => {
            // console.log('venue from CDIST', cdistReponse);
            const venueFound = cdistReponse.result.filter(v => v.code === response.workflow.venue_id);
            let venue: CdVenueModel = null;
            let clients = [];
            if (venueFound.length) {
              venue = venueFound[0];
              return this.venuesService.getByKey(venue.key).subscribe(venueResponse => {

                // todo
                //! response will change from array to obj.data
                if (venueResponse.data && venueResponse.data.length) {
                  venue.name = venueResponse.data[0].name;
                  venue.country = venueResponse.data[0].country;
                }
                // todo

                if (venueFound[0].clients.length) {
                  const keys = venue.clients.map(c => c.key);
                  // Get client names
                  return this.clientAuthAPIService.getClientsByKeys({ keys: keys }).subscribe(res => {
                    clients = res;
                    // console.log(clients);
                    subscriber.next({ workflow: response.workflow, venue, clients });
                    subscriber.complete();
                  });
                } else {
                  subscriber.next({ workflow: response.workflow, venue, clients });
                  subscriber.complete();
                  return { workflow: response.workflow, venue, clients };
                }
              });
            } else {
              subscriber.next({ workflow: response.workflow, venue, clients });
              subscriber.complete();
              return { workflow: response.workflow, venue, clients };
            }
          });
        });
      }),
      catchError(error => {
        this.toastr.error('', 'Se ha producido un error');
        this.router.navigate(['/sitesbuilder/private/workflows']);
        return of({ flow: null, error: error });
      })
    );
  }
}

@Injectable({
  providedIn: 'root',
})
export class FlowSitesListResolver {
  constructor(
    private sbApiService: SbApiService,
    private toastr: ToastrService
  ) { }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let page = 1;
    if (route.queryParams.page) {
      page = route.queryParams.page;
    }
    let editordemos = false;
    let isTest = false;
    if (route.queryParams.tab && route.queryParams.tab === 'editor2dmaps') {
      editordemos = true;
    }
    let testing = false;
    if (route.queryParams.tab && route.queryParams.tab === 'testing') {
      testing = true;
    }

    return this.sbApiService.getSitesList(page, null, editordemos, testing).pipe(
      map(site => site),
      catchError(error => {
        console.log(error);
        this.toastr.error('', 'Se ha producido un error');
        return of({ flow: null, error: error });
      })
    );
  }
}

@Injectable({
  providedIn: 'root',
})
export class FlowClientSitesListResolver {
  constructor(
    private sbApiService: SbApiService,
    private toastr: ToastrService
  ) { }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let page = null;
    if (route.queryParams.page) {
      page = route.queryParams.page;
    }
    return this.sbApiService.getSitesByClient(page).pipe(
      map(clientSite => clientSite),
      catchError(error => {
        console.log(error);
        this.toastr.error('', 'Se ha producido un error');
        return of({ flow: null, error: error });
      })
    );
  }
}

@Injectable({
  providedIn: 'root',
})
export class FlowSiteResolver {
  constructor(private sbApiService: SbApiService) { }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const siteId = route.params.siteId;
    return this.sbApiService.getSite(siteId).pipe(map(site => site));
  }
}

@Injectable({
  providedIn: 'root',
})
export class FlowSiteMasterFileResolver {
  constructor(
    private sbApiService: SbApiService,
    private toastr: ToastrService,
    private cdistApiService: ContentDistributionApiService,
    private venuesService: VenuesService,
    private clientAuthAPIService: ClientService
  ) { }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const siteId = route.params.siteId;
    return this.sbApiService.getSite(siteId).pipe(
      mergeMap(response => {
        return new Observable<{
          site: SiteModel;
          master: MinisiteConfiguration;
          venue: CdVenueModel;
          clients: ClientListFromKeys[];
        }>(subscriber => {
          // Check ovewrite query params
          let p = route.queryParams;
          if (p['venue_id'] && p['map_id']) {
            response.site.map_id = p['map_id'];
            response.site.venue_code = p['venue_id'];
          }
          console.log('Site: ', response.site);
          return this.sbApiService.getMasterFile(response.site.path_master).subscribe(masterResult => {
            // console.log('Master: ', masterResult);
            return this.cdistApiService.getClientsByCode(response.site.venue_code).subscribe(cdistReponse => {
              // console.log('venue from CDIST', cdistReponse);
              const venueFound = cdistReponse.result.filter(v => v.code === response.site.venue_code);
              let venue: CdVenueModel = null;
              let clients = [];
              if (venueFound.length) {
                venue = venueFound[0];
                return this.venuesService.getByKey(venue.key).subscribe(venueResponse => {

                  // todo
                  //! response will change from array to obj.data
                  if (venueResponse.data && venueResponse.data.length) {
                    venue.name = venueResponse.data[0].name;
                    venue.country = venueResponse.data[0].country;
                  }
                  // todo

                  if (venueFound[0].clients.length) {
                    const keys = venue.clients.map(c => c.key);
                    // Get client names
                    return this.clientAuthAPIService.getClientsByKeys({ keys: keys }).subscribe(res => {
                      clients = res;
                      // console.log(clients);
                      subscriber.next({ site: response.site, master: masterResult, venue, clients });
                      subscriber.complete();
                    });
                  } else {
                    subscriber.next({ site: response.site, master: masterResult, venue, clients });
                    subscriber.complete();
                    return { site: response.site, venue, clients };
                  }
                });
              } else {
                subscriber.next({ site: response.site, master: masterResult, venue, clients });
                subscriber.complete();
                return { workflow: response.site, venue, clients };
              }
            });
          });
        });
      }),
      catchError(error => {
        console.log(error);
        this.toastr.error('', 'Se ha producido un error');
        return of({ flow: null, error: error });
      })
    );
  }
}

@Injectable({
  providedIn: 'root',
})
export class SiteInProgressResolver {
  constructor(private sblibService: SblibService) { }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return new Observable<MinisiteConfiguration | null>(subscriber => {
      const minisiteInProgress = JSON.parse(localStorage.getItem('minisiteInProgress')) as MinisiteConfiguration;
      // Recover editing
      let keytools = JSON.parse(localStorage.getItem('minisiteInProgressToolKeys'));
      if (minisiteInProgress && keytools && keytools.length) {
        let promises = [];
        for (let i = 0; i < keytools.length; i++) {
          let key = keytools[i];
          let data = JSON.parse(localStorage.getItem(key));
          let p = this.sblibService.recoverFromLocalStorage(data);
          promises.push(p);
        }
        Promise.all(promises)
          .then(res => {
            if (res.length) {
              res.forEach(i => {
                let toolkey = i.meta.tool;
                if (toolkey === 'logo' && i.file) {
                  minisiteInProgress.toolsConfig.logo.file = i.file;
                }
                if (toolkey === 'multivenue') {
                  let tab = i.meta.key.split('_')[1];
                  minisiteInProgress.toolsConfig.multivenue.venues[tab].file = i.file;
                }
              });
            }
            subscriber.next(minisiteInProgress);
            subscriber.complete();
          })
          .catch(err => {
            subscriber.next(null);
            subscriber.complete();
          });
      } else {
        subscriber.next(null);
        subscriber.complete();
      }
    });
  }
}
